import React, { useState, useEffect, useMemo } from 'react';
import { Button, Card, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { EmployeeActivityRow, EmployeeActivityRowHeader, EmployeeActivityTotalsRow } from './';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
export const EmployeesActivitySection = _ref => {
  let {
    claim,
    refreshClaim,
    project
  } = _ref;
  const [claimEmployees, setClaimEmployees] = useState(null);
  const dispatch = useDispatch();
  const claimId = useMemo(() => claim === null || claim === void 0 ? void 0 : claim.id, [claim]);
  const user = useSelector(state => state.auth.user);
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId, project.id));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end mb-2"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pb-5"
  }), /*#__PURE__*/React.createElement(Table, {
    size: "md"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(EmployeeActivityRowHeader, {
    claim: claim
  })), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((_, index) => {
    return /*#__PURE__*/React.createElement(EmployeeActivityRow, {
      key: index,
      index: index,
      claim: claim,
      refreshClaim: refreshClaim,
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      claimEmployeesService: claimEmployeesService,
      handleError: handleError,
      claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService
    });
  }), /*#__PURE__*/React.createElement(EmployeeActivityTotalsRow, {
    claim: claim
  })))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: "/".concat(user.account_type, "/claims/").concat(claim.id, "/financial_details/employees_bio")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(user.account_type, "/claims/").concat(claim.id, "/financial_details/wages")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))))));
};